<ion-list lines="none">
  <ion-item *ngFor="let lang of supportedLanguages" (click)="selectLanguage(lang)">
    <div [class]="['flag', lang.cssClass]"></div>
    <span>{{ lang.label }}</span>
    <ion-icon *ngIf="spellChecker.currentLanguage === lang" slot="end" name="checkmark"></ion-icon>
  </ion-item>
</ion-list>
